<template>
    <!-- ---------------------------------- CARE ---------------------------------- -->
    <div class="care">
        <!-- ---------------------------------- 顶部导航栏 ---------------------------------- -->
        <Header></Header>
        <!-- ---------------------------------- 标签栏 ---------------------------------- -->
        <div class="care_tab">
            <span
                class="tab_main"
                :class="cur === index ? 'select_tab' : ''"
                v-for="(item, index) of tab"
                :key="index"
                @click="cur = index"
                >{{ item }}</span
            >
        </div>
        <!-- ---------------------------------- 标签页一 ---------------------------------- -->
        <div v-show="cur == 0" class="care_one">
            <!-- 海报图 -->
            <!--      <div class="banner">-->
            <!--        <div class="banner_main">-->
            <!--          <p>重现天然的感觉</p>-->
            <!--          <img src="../assets/images/icon/renoud-logo-orange.png" alt="">-->
            <!--        </div>-->
            <!--      </div>-->
            <div v-if="imgList1.length > 1">
                <swiper :options="swiperOption">
                    <swiper-slide
                        v-for="(item, index) in imgList1"
                        :key="index"
                    >
                        <img
                            class="banner"
                            @click="tiaoZhuan1(index)"
                            v-lazy="
                                'http://118.89.87.102:8080/jeecg-boot/sys/common/static/' +
                                item.imgUrl
                            "
                            alt=""
                        />
                        <p
                            style="
                                margin: 5% 0;
                                position: absolute;
                                top: 60%;
                                color: #fff;
                                font-size: 60px;
                                left: 50%;
                            "
                            v-html="item.remarks"
                        ></p>
                        <!--            <img class="banner" :src="'http://192.168.71.1:8082/jeecg-boot/sys/common/static/'+item.imgUrl" alt="">-->
                    </swiper-slide>
                    <div class="swiper-pagination" slot="pagination"></div>
                    <div class="swiper-button-prev" slot="button-prev"></div>
                    <div class="swiper-button-next" slot="button-next"></div>
                </swiper>
                <!--如果你需要分页-->
                <div class="swiper-pagination" slot="pagination"></div>
                <!--如果需要前进后退按钮-->
                <div class="swiper-button-next2"></div>
                <div class="swiper-button-prev2"></div>
            </div>
            <div v-if="imgList1.length <= 1" class="banner">
                <div v-for="(item, index) in imgList1" :key="index">
                    <div class="banner_main">
                        <p>重现天然的感觉</p>
                        <img
                            src="../assets/images/icon/renoud-logo-orange.png"
                            @click="tiaoZhuan1(index)"
                            alt=""
                        />
                    </div>
                    <div
                        class="propk"
                        v-if="item.video"
                        style="margin-left: 50%"
                    >
                        <el-popover
                            placement="top-start"
                            width="200"
                            trigger="hover"
                            :visible-arrow="false"
                        >
                            <iframe
                                :src="item.video"
                                frameborder="0"
                                width="500"
                                height="300"
                            ></iframe>
                            <img
                                src="../assets/images/bofang.png"
                                slot="reference"
                                class="bfbtn"
                            />
                        </el-popover>
                    </div>
                    <!--            <img class="banner" @click="tiaoZhuan1(index)" :src="'http://118.89.87.102:8080/jeecg-boot/sys/common/static/'+item.imgUrl" alt="">-->
                    <!--            <p style="margin:5% 0;position:absolute;top: 60%; color: #fff;font-size:60px;left: 50%" v-html="item.remarks"></p>-->
                    <!--            <img class="banner" :src="'http://192.168.71.1:8082/jeecg-boot/sys/common/static/'+item.imgUrl" alt="">-->
                </div>
            </div>
            <!-- 标语 -->
            <div class="slogan">
                <p>
                    蔚诺提供空气净化机清洁服务<br />我们的团队专业、贴心、专注细节，将您的空气净化机<br />焕然一新，重现天然感觉。
                </p>
            </div>
            <!-- 表格 -->
            <div class="one_form">
                <!-- 标签栏 -->
                <div class="form_tab">
                    <span
                        class="tab_main"
                        :class="formTabId === index ? 'select_foem_tab' : ''"
                        v-for="(oneItem, index) of formTab"
                        :key="index"
                        @click="formTabId = index"
                        >{{ oneItem }}</span
                    >
                </div>
                <!-- 标签页一 -->
                <div v-show="formTabId == 0" class="one_tab_one">
                    <!-- 表单 -->
                    <Form
                        :noArr="[
                            'models',
                            'eamil',
                            'adress',
                            'company',
                            'customer',
                            'nowDetection',
                            'serviceAddress',
                            'nowDetection',
                            'nowExtended',
                            'nowSpecial',
                            'nowDetectionOrigan',
                        ]"
                        :type="91"
                    ></Form>
                    <!-- 服务说明 -->
                    <div class="instructions">
                        <!-- 为什么更换滤网 -->
                        <div class="instructions_why">
                            <p>为何要更换滤网？</p>
                            <span
                                >防止污垢灰尘和细菌的堆积<br />防止发霉的和其他难闻的味道<br />净化器能更静音和更有效地运转<br />延长空气净化器的寿命<br />防止二次空气污染</span
                            >
                        </div>
                        <!-- 5Cs服务清单服务内容 -->
                        <div class="instructions_main">
                            <p>5C服务清单服务内容</p>
                            <span
                                >在清洁前后检查净化器<br />清洁初效滤网（如适用）<br />更换新的滤网<br />对净化器的里外进行清洁和消毒<br />免费进行室内空气质量检测</span
                            >
                        </div>
                    </div>
                    <!-- 对比 -->
                    <div class="contrast">
                        <div class="contrast_box">
                            <img
                                src="../assets/images/clean-before1.png"
                                alt=""
                            />
                            <img
                                src="../assets/images/after-cleaning1.png"
                                alt=""
                            />
                            <p>清洁前<span>></span>清洁后</p>
                        </div>
                        <div class="contrast_box">
                            <img
                                src="../assets/images/clean-before2.png"
                                alt=""
                            />
                            <img
                                src="../assets/images/after-cleaning2.png"
                                alt=""
                            />
                            <p>清洁前<span>></span>清洁后</p>
                        </div>
                        <div class="contrast_box">
                            <img
                                src="../assets/images/clean-before3.png"
                                alt=""
                            />
                            <img
                                src="../assets/images/after-cleaning3.png"
                                alt=""
                            />
                            <p>清洁前<span>></span>清洁后</p>
                        </div>
                    </div>
                    <!-- 费用 -->
                    <div class="cost">
                        <div>服务费￥300每台</div>
                        <p>
                            *新的滤网不包含在服务费中。请联系我们了解更换滤网的价格。
                        </p>
                    </div>
                </div>
                <!-- 标签页二 -->
                <!-- <div v-show="jhcur == 1">

        </div> -->
            </div>
        </div>
        <!-- ---------------------------------- 标签页二 ---------------------------------- -->
        <div v-show="cur == 1" class="care_two">
            <!-- 海报图 -->
            <!--      <div class="banner">-->
            <!--        <div class="banner_main">-->
            <!--          <p>让空气清新，让未来健康</p>-->
            <!--          <img src="../assets/images/icon/renoud-logo-orange.png" alt="">-->
            <!--        </div>-->
            <!--      </div>-->
            <div v-if="imgList2.length > 1">
                <swiper :options="swiperOption">
                    <swiper-slide
                        v-for="(item, index) in imgList2"
                        :key="index"
                    >
                        <img
                            class="banner"
                            @click="tiaoZhuan2(index)"
                            v-lazy="item.imgUrl"
                            alt=""
                        />
                        <p
                            style="
                                margin: 5% 0;
                                position: absolute;
                                top: 60%;
                                color: #fff;
                                font-size: 60px;
                                left: 50%;
                            "
                            v-html="item.remarks"
                        ></p>
                        <!--            <img class="banner" :src="'http://192.168.71.1:8082/jeecg-boot/sys/common/static/'+item.imgUrl" alt="">-->
                    </swiper-slide>
                    <div class="swiper-pagination" slot="pagination"></div>
                    <div class="swiper-button-prev" slot="button-prev"></div>
                    <div class="swiper-button-next" slot="button-next"></div>
                </swiper>
                <!--如果你需要分页-->
                <div class="swiper-pagination" slot="pagination"></div>
                <!--如果需要前进后退按钮-->
                <div class="swiper-button-next2"></div>
                <div class="swiper-button-prev2"></div>
            </div>
            <div v-if="imgList2.length <= 1" class="banner">
                <div v-for="(item, index) in imgList2" :key="index">
                    <div class="banner_main">
                        <p>让空气清新，让未来健康</p>
                        <img
                            src="../assets/images/icon/renoud-logo-orange.png"
                            @click="tiaoZhuan2(index)"
                            alt=""
                        />
                    </div>
                    <div
                        class="propk"
                        v-if="item.video"
                        style="margin-left: 50%"
                    >
                        <el-popover
                            placement="top-start"
                            width="200"
                            trigger="hover"
                            :visible-arrow="false"
                        >
                            <iframe
                                :src="item.video"
                                frameborder="0"
                                width="500"
                                height="300"
                            ></iframe>
                            <img
                                src="../assets/images/bofang.png"
                                slot="reference"
                                class="bfbtn"
                            />
                        </el-popover>
                    </div>
                    <!--            <img class="banner" @click="tiaoZhuan2(index)" :src="item.imgUrl" alt="">-->
                    <!--            <p style="margin:5% 0;position:absolute;top: 60%; color: #fff;font-size:60px;left: 50%" v-html="item.remarks"></p>-->
                    <!--            <img class="banner" :src="'http://192.168.71.1:8082/jeecg-boot/sys/common/static/'+item.imgUrl" alt="">-->
                </div>
            </div>
            <!-- 标语 -->
            <div class="slogan">
                <p>
                    合约期外保养服务<br />您的空气净化器需要定期更换滤网和彻底清洁。<br />需要延长您的保养服务吗?
                </p>
            </div>
            <!-- 表格 -->
            <div class="two_form">
                <!-- 标签栏 -->
                <div class="form_tab">
                    <span
                        class="tab_main"
                        :class="formTabId === index ? 'select_foem_tab' : ''"
                        v-for="(oneItem, index) of formTab"
                        :key="index"
                        @click="formTabId = index"
                        >{{ oneItem }}</span
                    >
                </div>
                <!-- 标签页一 -->
                <div v-show="formTabId == 0" class="two_tab_one">
                    <!-- 表单 -->
                    <Form
                        :noArr="[
                            'models',
                            'eamil',
                            'adress',
                            'company',
                            'customer',
                            'nowDetection',
                            'serviceAddress',
                            'nowDetection',
                            'nowExtended',
                            'nowSpecial',
                            'nowDetectionOrigan',
                        ]"
                        :type="92"
                    ></Form>
                </div>
                <!-- 标签页二 -->
                <!-- <div v-show="jhcur == 1">

        </div> -->
            </div>
        </div>
        <!-- ---------------------------------- 标签页三 ---------------------------------- -->
        <div v-show="cur == 2" class="care_three">
            <!-- 海报图 -->
            <div class="banner">
                <div class="banner_main">
                    <p>城市绿洲 · 在你左右</p>
                    <!-- <img src="../assets/images/icon/renoud-logo-orange.png" alt=""> -->
                </div>
            </div>
            <!-- 标语 -->
            <div class="slogan">
                <p>
                    Renaud专业团队可以随时上门提供室内空气检测服务。<br />我们能够通过仪器考察室内空气质量及浓度，并在检测完成后出具检测服务，<br />同时就结果提供专业室内空气改善建议。
                </p>
            </div>
            <!-- 表格 -->
            <div class="three_form">
                <!-- 标签栏 -->
                <div class="form_tab">
                    <span
                        class="tab_main"
                        :class="formTabId === index ? 'select_foem_tab' : ''"
                        v-for="(oneItem, index) of formTab"
                        :key="index"
                        @click="formTabId = index"
                        >{{ oneItem }}</span
                    >
                </div>
                <!-- 标签页一 -->
                <div v-show="formTabId == 0" class="three_tab_one">
                    <!-- 表单 -->
                    <Form
                        :noArr="[
                            'models',
                            'eamil',
                            'adress',
                            'company',
                            'customer',
                            'nowClean',
                            'serviceAddress',
                            'nowExtended',
                            'nowSpecial',
                            'nowDetection',
                        ]"
                        :type="9"
                    ></Form>
                    <!-- 测试范围 -->
                    <div class="scope">
                        <!-- 标题 -->
                        <p class="scope_title">测试范围</p>
                        <!-- 横线 -->
                        <div class="scope_line"></div>
                        <!-- 内容 -->
                        <div class="scope_main">
                            <!-- NAI -->
                            <div class="scope_box">
                                <!-- 图标 -->
                                <div class="scope_icon">NAI</div>
                                <!-- 文案 -->
                                <div class="scope_text">
                                    <p>负离子</p>
                                    <span
                                        >温湿度、气状况、植物绿化、建筑材料等都能影响空气负离子浓度的高低，从而影响环境的空气清新度。</span
                                    >
                                </div>
                            </div>
                            <!-- SO2 -->
                            <div class="scope_box">
                                <!-- 图标 -->
                                <div class="scope_icon">SO₂</div>
                                <!-- 文案 -->
                                <div class="scope_text">
                                    <p>二氧化硫</p>
                                    <span
                                        >二氧化硫是无色有刺激性气味的气体，对人的呼吸器官和眼膜具有刺激作用，长期吸入对呼吸系统、肝、肾、心脏都有危害。</span
                                    >
                                </div>
                            </div>
                        </div>
                        <!-- 内容 -->
                        <div class="scope_main">
                            <!-- CO2 -->
                            <div class="scope_box">
                                <!-- 图标 -->
                                <div class="scope_icon">CO₂</div>
                                <!-- 文案 -->
                                <div class="scope_text">
                                    <p>二氧化碳</p>
                                    <span
                                        >如果房间通风不良，二氧化碳会在室内积聚。室内高浓度的CO²会使人感到昏昏欲睡，引起头痛，难以集中注意力，头晕甚至恶心。</span
                                    >
                                </div>
                            </div>
                            <!-- NO2 -->
                            <div class="scope_box">
                                <!-- 图标 -->
                                <div class="scope_icon">NO₂</div>
                                <!-- 文案 -->
                                <div class="scope_text">
                                    <p>二氧化氮</p>
                                    <span
                                        >对于人体具有一定的毒性，浓度过高会影响肺部功能，导致肺活量下降。</span
                                    >
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- 视频 -->
                    <div class="videos">
                        <!-- 标题 -->
                        <p>只需简单一步，即可在家中享受清新空气</p>
                        <!-- 横线 -->
                        <div class="videos_line"></div>
                        <!-- 视频 -->
                        <div class="video_box">
                            <video
                                controls="controls"
                                autobuffer
                                width="100%"
                                height="440rem"
                                src="../assets/video/test.mp4"
                            ></video>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- ---------------------------------- 顶部导航栏 ---------------------------------- -->
        <Footer></Footer>
    </div>
</template>

<script>
import Header from '@/components/Header';
import Footer from '@/components/Footer';
import Form from '@/components/Form';
import { swiper, swiperSlide } from 'vue-awesome-swiper';
import 'swiper/dist/css/swiper.css';
import Axios from 'axios';
export default {
    components: {
        Header,
        Footer,
        swiper,
        swiperSlide,
        Form,
    },
    data() {
        return {
            imgList1: [],
            imgList2: [],
            swiperOption: {
                loop: true,
                autoplay: {
                    delay: 3000,
                    stopOnLastSlide: false,
                    disableOnInteraction: false,
                },
                // 显示分页
                pagination: {
                    el: '.swiper-pagination',
                    clickable: true, //允许分页点击跳转
                },
                // 设置点击箭头
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                },
            },
            tab: ['净化清洁服务', '合约期外保养服务'],
            formTab: ['咨询服务'],
            formTabId: 0,
            cur: 0,
            userAgent: {},
            isIphone13: false,
        };
    },
    created() {
        this.getImagesUrl1();
        this.getImagesUrl2();
        this.tiaoZhuan();

        let ua = window.navigator.userAgent.toLowerCase();
        this.userAgent = ua;
        if (ua.indexOf('15_1_1') > -1) {
            this.isIphone13 = true;
        }
    },
    mounted: function () {
        if (this.$route.params.cur != undefined) {
            this.cur = this.$route.params.cur;
        }
    },
    methods: {
        tiaoZhuan() {
            var that = this;
            let setId = this.$route.query.setId;
            if (setId === undefined) {
                that.tabId = 0;
            } else {
                that.cur = Number(setId);
            }
        },
        // banner点击页面跳转
        tiaoZhuan1(val) {
            var that = this;
            if (that.imgList1[val].lujing === null) {
                return;
            }
            window.location.href = that.imgList1[val].lujing;
        },
        // banner点击页面跳转
        tiaoZhuan2(val) {
            var that = this;
            if (that.imgList2[val].lujing === null) {
                return;
            }
            window.location.href = that.imgList2[val].lujing;
        },
        getImagesUrl1() {
            var that = this;
            var url =
                'http://118.89.87.102:8080/jeecg-boot/h5/h5Controller/getBannerImages?location=' +
                109 +
                '&category=' +
                91;
            // var url = "http://192.168.71.1:8082/jeecg-boot/h5/h5Controller/getBannerImages?location="+109+"&category="+91;
            Axios.get(url).then((res) => {
                if (res.data.success === true) {
                    for (let i = 0; i < res.data.result.length; i++) {
                        that.imgList1.push({
                            lujing: res.data.result[i].backup1,
                            imgUrl: res.data.result[i].picUrl,
                            remarks: res.data.result[i].remarks,
                            video: res.data.result[i].backup2,
                        });
                    }
                }
            });
        },
        getImagesUrl2() {
            var that = this;
            var url =
                'http://118.89.87.102:8080/jeecg-boot/h5/h5Controller/getBannerImages?location=' +
                109 +
                '&category=' +
                92;
            // var url = "http://192.168.71.1:8082/jeecg-boot/h5/h5Controller/getBannerImages?location="+109+"&category="+92;
            Axios.get(url).then((res) => {
                if (res.data.success === true) {
                    for (let i = 0; i < res.data.result.length; i++) {
                        that.imgList2.push({
                            lujing: res.data.result[i].backup1,
                            imgUrl: res.data.result[i].picUrl,
                            remarks: res.data.result[i].remarks,
                            video: res.data.result[i].backup2,
                        });
                    }
                }
            });
        },
    },
};
</script>

<style lang="less" scoped>
.propk {
    width: 50px;
    position: absolute;
    top: 50%;
    text-align: center;
}
.banner .bfbtn {
    width: 40px;
    height: 40px;
}

// ---------------------------- 标签栏 ---------------------------------
// ------------- mobile端样式 -------------
@media only screen and (max-width: 960px) {
    // 屏幕小于960px
    .care_tab {
        padding: 70px 0;
        // 标签默认样式
        .tab_main {
            font-size: 44px;
            padding: 15px 45px;
            line-height: 44px;
        }
    }
}
// ------------- pc端样式 -------------
@media only screen and (min-width: 960px) {
    // 屏幕大于960px
    .care_tab {
        padding: 40px 0;
        // 标签默认样式
        .tab_main {
            font-size: 20px;
            padding: 3px 30px;
        }
    }
}
.care_tab {
    width: 100%;
    background-color: #9f9fa0;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    // 标签默认样式
    .tab_main {
        color: #fff;
        border: 1px solid #fff;
        border-radius: 50px;

        margin: 0 50px;
        cursor: pointer;
    }
    // 标签选中样式
    .select_tab {
        background-color: #fff;
        color: #6d6c6c;
    }
}

// ---------------------------- 标签页一 ---------------------------------
// ------------- mobile端样式 -------------
@media only screen and (max-width: 960px) {
    // 屏幕小于960px
    // 海报图
    .banner_main {
        p {
            font-size: 80px;
        }
        img {
            width: 477px;
        }
    }
    // 标语
    .slogan {
        height: 405px;
        p {
            font-size: 54px;
        }
    }
    // 标签
    .tab_main {
        font-size: 46px;
        padding: 0 160px 0 100px;
        line-height: 2.4;
    }
    // 为什么更换滤网
    .instructions_why {
        p {
            font-size: 50px;
        }
        span {
            font-size: 46px;
        }
    }
    // 5Cs服务清单服务内容
    .instructions_main {
        p {
            font-size: 50px;
        }
        span {
            font-size: 46px;
        }
    }
    // 对比
    .contrast {
        .contrast_box {
            text-align: center;
            img {
                width: 35%;
                margin: 0 4% 0 4%;
            }
            p {
                font-size: 56px;
                margin-top: 3%;
                span {
                    display: block;
                    margin: 0 16%;
                }
            }
        }
    }
    // 费用
    .cost {
        div {
            width: 672px;
            font-size: 56px;
            line-height: 135px;
        }
        p {
            font-size: 46px;
        }
    }
}
// ------------- pc端样式 -------------
@media only screen and (min-width: 960px) {
    // 屏幕大于960px
    // 海报图
    .banner_main {
        p {
            font-size: 60px;
        }
        img {
            width: 337px;
        }
    }
    // 标语
    .slogan {
        height: 305px;
        p {
            font-size: 34px;
            font-weight: lighter;
        }
    }
    // 标签
    .tab_main {
        font-size: 22px;
        padding: 0 110px 0 50px;
        line-height: 2.8;
    }
    // 为什么更换滤网
    .instructions_why {
        p {
            font-size: 38px;
        }
        span {
            font-size: 32px;
        }
    }
    // 5Cs服务清单服务内容
    .instructions_main {
        p {
            font-size: 38px;
        }
        span {
            font-size: 32px;
        }
    }
    // 对比
    .contrast {
        display: flex;
        align-items: center;
        justify-content: space-evenly;
        .contrast_box {
            img {
                width: 251px;
                margin: 0 5px 0 5px;
            }
            p {
                font-size: 26px;
                span {
                    display: block;
                    margin: 0 10px;
                }
            }
        }
    }
    // 费用
    .cost {
        div {
            width: 522px;
            font-size: 46px;
            line-height: 105px;
        }
        p {
            font-size: 30px;
        }
    }
}
.care_one {
    width: 100%;
    background-color: #fff;
    // 海报图
    .banner {
        width: 100%;
        height: 551px;
        background: url('../assets/images/care-banner1.png') no-repeat;
        background-size: 100% 100%;
        background-position: center;
        position: relative;
        .banner_main {
            position: absolute;
            top: 32%;
            right: 13%;
            p {
                color: #112653;
                letter-spacing: 10px;
                margin: 0 0 30px 0;
                text-align: center;
            }
            img {
                display: block;
                margin: 0 auto;
            }
        }
    }
    // 标语
    .slogan {
        width: 100%;
        background: url('../assets/images/care-bg.png') no-repeat;
        background-size: 100% 100%;
        background-position: center;
        p {
            color: #ffffff;
            letter-spacing: 5px;
            line-height: 1.5;
            margin: 0;

            text-align: center;
            padding-top: 3.3%;
        }
    }
    // 表格
    .one_form {
        width: 100%;
        // 标签栏
        .form_tab {
            text-align: center;
            margin-top: 30px;
            display: flex;
            justify-content: center;
            span {
                margin: 0 3%;
            }
            // 标签
            .tab_main {
                color: #ef844b;
                letter-spacing: 4px;
                box-shadow: 2px 4px 6px #cecece;
                background: url('../assets/images/form-tab-bg.png') no-repeat;
                background-size: 100% 100%;
                border-radius: 50px;
                cursor: pointer;
            }
        }
        // 子标签页一
        .one_tab_one {
            // 服务说明
            .instructions {
                width: 100%;
                display: flex;
                // 为什么更换滤网
                .instructions_why {
                    width: 50%;
                    background-color: #face9d;
                    text-align: center;
                    padding: 60px 0 90px 0;
                    p {
                        color: #f87734;
                        letter-spacing: 5px;
                        margin: 0 0 30px 0;
                        font-weight: bold;
                    }
                    span {
                        color: #464646;
                        letter-spacing: 5px;
                        line-height: 1.8;
                    }
                }
                // 5Cs服务清单服务内容
                .instructions_main {
                    width: 50%;
                    background-color: #fbdcbb;
                    text-align: center;
                    padding: 60px 0 90px 0;
                    p {
                        color: #f87734;
                        letter-spacing: 5px;
                        margin: 0 0 30px 0;
                        font-weight: bold;
                    }
                    span {
                        color: #464646;
                        letter-spacing: 5px;
                        line-height: 1.8;
                    }
                }
            }
            // 对比
            .contrast {
                width: 100%;
                padding: 80px 60px 50px 60px;
                background-color: #fef4e4;
                box-sizing: border-box;
                .contrast_box {
                    p {
                        color: #464646;
                        text-align: center;
                        display: flex;
                        align-content: center;
                        justify-content: center;
                    }
                }
            }
            // 费用
            .cost {
                width: 100%;
                padding: 80px 0 50px 0;
                div {
                    background-color: #f0844b;
                    border-radius: 100px;
                    text-align: center;
                    color: #ffffff;
                    font-weight: bold;
                    letter-spacing: 5px;
                    margin: 0 auto;
                    margin-bottom: 30px;
                }
                p {
                    color: #464646;
                    letter-spacing: 5px;
                    text-align: center;
                    line-height: 2;
                }
            }
        }
        // 子标签页二
    }
}

// ---------------------------- 标签页二 ---------------------------------
@media only screen and (max-width: 960px) {
    // 屏幕小于960px
    .care_two {
        text-align: right;
        // 海报图
        .banner_main {
            position: absolute;
            top: 32%;
            right: 10%;
            p {
                font-size: 80px;
            }
            img {
                width: 437px;
            }
        }
        // 标语
        .slogan {
            height: 385px;
            p {
                font-size: 50px;
            }
        }
        // 标签
        .tab_main {
            font-size: 46px;
            padding: 0 180px 0 120px;
        }
    }
}
// ------------- pc端样式 -------------
@media only screen and (min-width: 960px) {
    // 屏幕大于960px
    .care_two {
        // 海报图
        .banner_main {
            position: absolute;
            top: 42%;
            right: 10%;
            p {
                font-size: 60px;
            }
            img {
                width: 337px;
                display: block;
                margin: 0 auto;
            }
        }
        // 标语
        .slogan {
            height: 305px;
            p {
                font-size: 34px;
                font-weight: lighter;
            }
        }
        // 标签
        .tab_main {
            font-size: 22px;
            padding: 0 110px 0 50px;
        }
    }
}
.care_two {
    width: 100%;
    background-color: #fff;
    // 海报图
    .banner {
        width: 100%;
        height: 551px;
        background: url('../assets/images/care-banner2.png') no-repeat;
        background-size: 100% 100%;
        background-position: center;
        position: relative;
        .banner_main {
            p {
                color: #112653;
                letter-spacing: 10px;
                margin: 0 0 30px 0;
                text-align: center;
            }
        }
    }
    // 标语
    .slogan {
        width: 100%;
        background: url('../assets/images/care-bg.png') no-repeat;
        background-size: 100% 100%;
        background-position: center;
        p {
            color: #ffffff;
            letter-spacing: 5px;
            line-height: 1.5;
            margin: 0;
            text-align: center;
            padding-top: 3.3%;
        }
    }
    // 表格
    .two_form {
        width: 100%;
        // 标签栏
        .form_tab {
            text-align: center;
            margin-top: 30px;
            display: flex;
            justify-content: center;
            span {
                margin: 0 3%;
            }
            // 标签
            .tab_main {
                color: #ef844b;
                line-height: 2.8;
                letter-spacing: 4px;
                box-shadow: 2px 4px 6px #cecece;
                background: url('../assets/images/form-tab-bg.png') no-repeat;
                background-size: 100% 100%;
                border-radius: 50px;

                cursor: pointer;
            }
        }
        // 子标签页一
        // .two_tab_one{

        // }
    }
}
// ---------------------------- 标签页三 ---------------------------------
.care_three {
    width: 100%;
    background-color: #fff;
    // 海报图
    .banner {
        width: 100%;
        height: 551px;
        background: url('../assets/images/care-banner3.png') no-repeat;
        background-size: 100% 100%;
        background-position: center;
        position: relative;
        .banner_main {
            position: absolute;
            top: 40%;
            right: 8%;
            p {
                font-size: 60px;
                color: #112653;
                letter-spacing: 10px;
                margin: 0 0 30px 0;
                text-align: center;
            }
            img {
                width: 337px;
                display: block;
                margin: 0 auto;
            }
        }
    }
    // 标语
    .slogan {
        width: 100%;
        height: 305px;
        background: url('../assets/images/care-bg.png') no-repeat;
        background-size: 100% 100%;
        background-position: center;
        p {
            font-size: 34px;
            color: #ffffff;
            letter-spacing: 5px;
            line-height: 1.5;
            margin: 0;
            font-weight: lighter;
            text-align: center;
            padding-top: 3.3%;
        }
    }
    // 表格
    .three_form {
        width: 100%;
        // 标签栏
        .form_tab {
            text-align: center;
            margin-top: 30px;
            display: flex;
            justify-content: center;
            span {
                margin: 0 3%;
            }
            // 标签
            .tab_main {
                font-size: 22px;
                color: #ef844b;
                line-height: 2.8;
                letter-spacing: 4px;
                box-shadow: 2px 4px 6px #cecece;
                background: url('../assets/images/form-tab-bg.png') no-repeat;
                background-size: 100% 100%;
                border-radius: 50px;
                padding: 0 110px 0 50px;
                cursor: pointer;
            }
        }
        // 子标签页一
        .three_tab_one {
            // 测试范围
            .scope {
                width: 100%;
                background-color: #fbdcbb;
                padding: 70px 0 0 0;
                // 标题
                .scope_title {
                    font-size: 40px;
                    color: #f29425;
                    letter-spacing: 8px;
                    text-align: center;
                    margin: 0;
                }
                // 横线
                .scope_line {
                    width: 345px;
                    margin: 0 auto;
                    border-bottom: 3px solid #f29425;
                    margin-top: 20px;
                    margin-bottom: 70px;
                }
                // 内容
                .scope_main {
                    width: 77%;
                    margin: 0 auto;
                    display: flex;
                    justify-content: space-between;
                    .scope_box {
                        display: flex;
                        margin-bottom: 100px;
                        // 图标
                        .scope_icon {
                            width: 113px;
                            height: 113px;
                            background-color: #f0844b;
                            font-size: 26px;
                            color: #ffffff;
                            letter-spacing: 4px;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            border-radius: 200px;
                            margin-right: 30px;
                        }
                        // 文案
                        .scope_text {
                            width: 533px;
                            font-size: 30px;
                            color: #636363;
                            letter-spacing: 3px;
                            p {
                                font-weight: bold;
                                margin: 0;
                            }
                            span {
                                line-height: 1.5;
                            }
                        }
                    }
                }
            }
            // 视频
            .videos {
                width: 100%;
                background-color: #fbf4ec;
                padding: 80px 0 90px 0;
                // 标题
                p {
                    font-size: 46px;
                    color: #727171;
                    letter-spacing: 10px;
                    text-align: center;
                    margin: 0;
                }
                // 横线
                .videos_line {
                    width: 1042px;
                    margin: 0 auto;
                    border-bottom: 3px solid #5a357e;
                    margin-top: 20px;
                    margin-bottom: 50px;
                }
                // 视频
                .video_box {
                    width: 45%;
                    margin: 0 auto;
                }
                .recommendPage .swiper-container {
                    position: relative;
                    width: 100%;
                    height: 200px;
                    background: pink;
                }
                .recommendPage .swiper-container .swiper-slide {
                    width: 100%;
                    line-height: 200px;
                    background: yellowgreen;
                    color: #000;
                    font-size: 16px;
                    text-align: center;
                }
            }
        }
    }
}
img[lazy='loading'] {
    width: 30%;
    height: 30%;
    margin-left: 30%;
    margin-top: -2%;
}
</style>



// WEBPACK FOOTER //
// src/view/care.vue